// extracted by mini-css-extract-plugin
var _1 = "marker-WPLzj";
var _2 = "name-KxGs0";
var _3 = "notice-Qlhr1";
var _4 = "wrapper-wc_4N";
export { _1 as "marker", _2 as "name", _3 as "notice", _4 as "wrapper" }
